import styled from 'styled-components';

export const SectionHeader = styled.h1.attrs(() => ({
  className: `text-2xl md:text-4xl text-center app-font`,
}))`
  letter-spacing: 7px;
  margin: 2rem 0;
`;
// text-shadow: 0 2px 12px #f0f;
